import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Logo from './Logo';
import PrideLogo from './Logo.pride22';
export default withFeatureBranch({
    pride22: PrideLogo,
})(Logo);
//# sourceMappingURL=index.js.map